module.exports = new __parcel__URL__("scratch03.9e26d81c.png").toString();